import { useRef } from "react"
import { ANIMATE_DELAY, ANIMATED_STYLE } from "src/libs/interfaces/animated"
import { getAnimateDelay } from "../../../utils/getAnimateDelay"
import { useAnimated } from "src/modules/pe-landing-module/hooks/useAnimated"
import { useAnimatedStyle } from "src/modules/pe-landing-module/hooks/useAnimatedStyle"

/* Protopia Ecosystem component */
export interface IPassageImageContainerProps {
    children: JSX.Element
    width: number| string
    height: number| string
    i: number
    animated?: ANIMATED_STYLE[]
    animated_delay?: number | ANIMATE_DELAY
}
const PassageImageContainer = (props: IPassageImageContainerProps): JSX.Element => {  
    const animated_delay = getAnimateDelay(props.animated_delay, props.i)
    const ref = useRef(null)
    useAnimated( ref, animated_delay )
    const animate   = useAnimatedStyle( props, props.i)
    return <div className={`pe-passage-image-container  ${animate}`} ref={ref}> 
        { props.children } 
    </div>
}
export default PassageImageContainer